import {FC} from 'react';
import {
	MY_TAX_NOT_SELF_EMPLOYED_DESCRIPTION,
	MY_TAX_NOT_SELF_EMPLOYED_TITLE,
} from '../../model';
import {MyTaxAccessWarningIcon} from 'shared/assets/icons';
import {StepLayout} from 'features/registration';
import styles from './MyTaxNotSelfEmployedStep.module.css';

export const MyTaxNotSelfEmployedStep: FC = () => {
	return (
		<StepLayout variant="fill" className={styles.root}>
			<StepLayout.Intro title={MY_TAX_NOT_SELF_EMPLOYED_TITLE} subtitle={MY_TAX_NOT_SELF_EMPLOYED_DESCRIPTION} />

			<StepLayout.Illustration>
				<MyTaxAccessWarningIcon className={styles.warningIcon} />
			</StepLayout.Illustration>
		</StepLayout>
	);
};
